import { useMemo } from "react";

import { useGetExperiencesList } from "@src/api/experiences-list/get-experiences-list";

export const useIsShippingTestAlreadyActive = () => {
  const experiencesList = useGetExperiencesList({ category: "experiment" });

  return useMemo(
    () =>
      (experiencesList.data?.experiencesList
        ?.filter((experience) => experience.status === "started")
        ?.filter((experience) => experience.testTypes.hasTestShipping)
        ?.length || 0) > 0,
    [experiencesList]
  );
};
